import { type FC } from 'react';

import { IconDownload, IconLoader2, IconPlayerPlay } from '@tabler/icons-react';
import { ButtonField } from '@wk/components-react16';

interface SiteDetailToolbarProps {
  isExportingHistoryCsv: boolean;
  onExportHistory: () => void;
  onRunEvaluation: () => void;
}

const SiteDetailToolbar: FC<SiteDetailToolbarProps> = ({
  isExportingHistoryCsv,
  onExportHistory,
  onRunEvaluation,
}) => (
  <div className="flex w-full justify-end gap-4 max-sm:flex-col">
    <div className="flex gap-3 justify-between max-sm:w-full">
      <ButtonField mode="ghost" size="small">
        <button
          disabled={isExportingHistoryCsv}
          onClick={onExportHistory}
        >
          {isExportingHistoryCsv ? (
            <IconLoader2 className="animate-spin" size={14} />
          ) : (
            <IconDownload size={14} />
          )}
          Export history CSV
        </button>
      </ButtonField>
      <ButtonField mode="ghost" size="small">
        <button onClick={onRunEvaluation}>
          <IconPlayerPlay size={14} />
          Run evaluation
        </button>
      </ButtonField>
    </div>
  </div>
);

export default SiteDetailToolbar;